/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_What_Is_Gridcraft_Sections_8_Questions_1_AnswerInputs */

const en_gc_search_guides_what_is_gridcraft_sections_8_questions_1_answer = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_8_Questions_1_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. The online editor lets you launch the browser build and work with a sample. A desktop browser with a keyboard is a more practical way to explore a full spreadsheet than a narrow phone screen.`)
};

const zh_gc_search_guides_what_is_gridcraft_sections_8_questions_1_answer = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_8_Questions_1_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不需要。在线编辑器可以启动浏览器构建并使用示例。相比狭窄的手机屏幕，带键盘的桌面浏览器更适合体验完整电子表格操作。`)
};

/**
* | output |
* | --- |
* | "No. The online editor lets you launch the browser build and work with a sample. A desktop browser with a keyboard is a more practical way to explore a full s..." |
*
* @param {Gc_Search_Guides_What_Is_Gridcraft_Sections_8_Questions_1_AnswerInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_what_is_gridcraft_sections_8_questions_1_answer = /** @type {((inputs?: Gc_Search_Guides_What_Is_Gridcraft_Sections_8_Questions_1_AnswerInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_What_Is_Gridcraft_Sections_8_Questions_1_AnswerInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_what_is_gridcraft_sections_8_questions_1_answer(inputs)
	return zh_gc_search_guides_what_is_gridcraft_sections_8_questions_1_answer(inputs)
});
export { gc_search_guides_what_is_gridcraft_sections_8_questions_1_answer as "gc.search_guides.what_is_gridcraft.sections.8.questions.1.answer" }